import React, { useEffect, useState } from 'react'
import { useAppSelector } from '../../../../slices/store'
import { Button } from '../../../../ui/Button/Button';
import { getWebSocket } from '../../../../socket/socket';
import { EStages } from '../../../../utils/types';
import { StyledVote } from './styles';
import { Link } from '@mui/material';
import clsx from 'clsx';
import { useDispatch } from 'react-redux';
import { setChosenUser } from '../../../../slices/main/mainSlice';

export const Vote = () => {
  const dispatch = useDispatch();
  const { allUsers, chosenUser, voteSong, isAdmin } = useAppSelector((s) => s.mainStore);

  const isValidURL = (url: string) => {
    try {
      new URL(url);
      return true;
    } catch(e) {
      return false;
    }
  };

  const handleChooseUser = (user: string) => {
    const ws = getWebSocket();
    ws?.send(JSON.stringify({type: EStages.vote, user_name: user}));
    dispatch(setChosenUser(user));
  }

  return (
    <StyledVote>
      {voteSong && isAdmin && <>
        <div>You're admin, play this song to other participants:</div>
        <Link href={isValidURL(voteSong) ? voteSong : 'https://www.google.com/'} target='_blank'>{voteSong}</Link>
      </>
      }
      <div className='description'>
        Vote for the user whose song has played:
      </div>
      <div className='users-list'>
        {allUsers.map((user) => <Button className={clsx({'chosen': chosenUser === user})} disabled={!!chosenUser} title={user + (chosenUser === user ? ' - chosen' : '')} handleClick={() => handleChooseUser(user)} width={200} />)}
      </div>
    </StyledVote>
  )
}
